import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../context/authContext";
import "./MySubmissions.css";
import SubmissionUpdateCard from "./UpdateCard/SubmissionUpdateCard ";
import { GettingSubmissions } from "../../../Functions/CRUD/Submission/submissionHelper";
import LoadingPage from "../../../Error/LoadingPage/LoadingPage";

const MySubmissions = () => {
  const [submissions, setsubmissions] = useState(null);
  const [SubmissionFound, setSubmissionFound] = useState(null);
  const { user } = useContext(AuthContext);
  const fetchAllSubmissions = async () => {
    try {
      const data = await GettingSubmissions(user._id, {}); // no need to pass {} unless you have params
      console.log(data);
      setSubmissionFound(data.found);
      setsubmissions(data.data);
    } catch (err) {
      console.error("Error fetching submissions:", err);
    }
  };

  useEffect(() => {
    setSubmissionFound(null);
    fetchAllSubmissions();
  }, []);

  if (SubmissionFound === null) {
    return <LoadingPage />;
  }

  return (
    <div className="MySubmission-Page">
      <h1>My Submissions :</h1>
      <p>
        <b>Purpose :</b> this section is designed to help users track their
        problem-solving journey by providing a dedicated space to submit
        solutions, view past attempts, and receive feedback. It ensures that
        students can stay organized, monitor their progress over time, and
        benefit from personalized corrections and comments — all in one
        accessible place.
      </p>
      {SubmissionFound ? (
        <SubmissionUpdateCard submissions={submissions} />
      ) : (
        <div className="submissions-table-container">
          <p>
            Here you'd find all your previous submissions. If encountered with
            any problem please make sure to report it right away to us and it
            would be reviewed as soon as possible.
          </p>
          <hr />
          <p style={{ color: "red" }}>
            You don't have any live submissions at the moment ...
          </p>
        </div>
      )}
    </div>
  );
};

export default MySubmissions;
